/*
  MIT License

  Copyright (c) 2022 Open Source  UOM

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.

  Made by Open Source UoM (https://opensource.uom.gr)

  Project members:
    -Apostolidis
    -Davios
    -Iosifidis
    -Konstantinidis
    -Mpakalis
    -Nasis
    -Omiliades
    -Patsouras
    -Fakidis

*/
import i18n from "../../i18n";

const secrData = [
  {
    name: i18n.t("eco_department"),
    email: "ecosecr@uom.edu.gr",
    tel: "2310 891.119, 149, 211, 265, 656",
    link: "https://www.uom.gr/eco/grammateia",
  },
  {
    name: i18n.t("bso_department"),
    email: "bsosecr@uom.gr",
    tel: "2310891375, 2310891645, 2310891433",
    link: "https://www.uom.gr/bso/grammateia",
  },
  {
    name: i18n.t("dai_department"),
    email: "daisecr@uom.edu.gr",
    tel: "2310.891 158",
    link: "https://www.uom.gr/dai/grammateia",
  },
  {
    name: i18n.t("ba_department"),
    email: "basecr@uom.edu.gr",
    tel: "2310 891.283, 2310 891.213, 2310 891.646, 2310 891.214",
    link: "https://www.uom.gr/ba/grammateia",
  },
  {
    name: i18n.t("fin_department"),
    email: "finsecr@uom.edu.gr",
    tel: "2310891607, 2310891441",
    link: "https://www.uom.gr/fin/grammateia",
  },
  {
    name: i18n.t("ies_department"),
    email: "essecr@uom.edu.gr",
    tel: "2310 891.285",
    link: "https://www.uom.gr/ies/grammateia",
  },
  {
    name: i18n.t("esp_department"),
    email: "espsecr@uom.edu.gr",
    tel: "2310.891258, 2310891339, 2310 891339, 2310 891253",
    link: "https://www.uom.gr/esp/epikoinonia",
  },
  {
    name: i18n.t("msa_department"),
    email: "msasecr@uom.edu.gr",
    tel: "2310 891.281, 2310 891.902",
    link: " https://www.uom.gr/msa/grammateia-tmhmatos",
  },
];

export default secrData;
